<template>
    <v-dialog value="true" max-width="300px">
        <v-card>
            <v-card-title>
                <span class="headline">
                <v-icon>mdi-alert</v-icon>
                    Not found
                </span>
            </v-card-title>
        </v-card>
    </v-dialog>

</template>
<script>
    export default {
        name: 'NotFoundComponent '
    }
</script>
